'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

exports.default = _setIn;

var _count2 = require('./_count');

var _count3 = _interopRequireDefault(_count2);

var _has2 = require('./_has');

var _has3 = _interopRequireDefault(_has2);

var _get2 = require('./_get');

var _get3 = _interopRequireDefault(_get2);

var _keyedEquivalent2 = require('./_keyedEquivalent');

var _keyedEquivalent3 = _interopRequireDefault(_keyedEquivalent2);

var _reduce2 = require('./_reduce');

var _reduce3 = _interopRequireDefault(_reduce2);

var _set2 = require('./_set');

var _set3 = _interopRequireDefault(_set2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function makeSetStack(keyPath, subject) {
  return (0, _reduce3.default)([], function (acc, key) {
    if (!acc.length) {
      acc.push([subject, key]);
      return acc;
    }

    var _acc = _slicedToArray(acc[acc.length - 1], 2),
        prevValue = _acc[0],
        prevKey = _acc[1];

    var actualValue = (0, _get3.default)(prevKey, prevValue);
    var nextValue = actualValue === undefined && !(0, _has3.default)(prevKey, prevValue) ? (0, _keyedEquivalent3.default)(prevValue) : actualValue;
    acc.push([nextValue, key]);
    return acc;
  }, keyPath);
}

function _setIn(keyPath, value, subject) {
  if ((0, _count3.default)(keyPath) === 0) {
    return value;
  }
  var setStack = makeSetStack(keyPath, subject);
  var result = value;
  while (setStack.length > 0) {
    var _setStack$pop = setStack.pop(),
        _setStack$pop2 = _slicedToArray(_setStack$pop, 2),
        layer = _setStack$pop2[0],
        key = _setStack$pop2[1];

    result = (0, _set3.default)(key, result, layer);
  }
  return result;
}
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/transmute/static-2.3/internal/_setIn.js
// module id = 182
// module chunks = 0 1